/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.modals.request.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.resources',
  'acme.common.factory.notice',
  'acme.common.directive.resourceRequest'
])

.controller('ResourcesModalsRequestController', ['$scope', '$uibModalInstance', 'ApiService', 'ResourcesService', 'CalendarService', 'HelpersService', 'NoticeFactory', 'resourceCategory', 'schedule', 'templateId', 'request', 'preset', 'type', 'emailSetting', 'showEmailNotification', function($scope, $uibModalInstance, ApiService, ResourcesService, CalendarService, HelpersService, NoticeFactory, resourceCategory, schedule, templateId, request, preset, type, emailSetting, showEmailNotification) {

    $scope.resourcesModalsRequest = {

      model: {
        schedule: {},
        resourceTimeFrame: {},
        eventResource: {},
        type: '',
        preset: 'standard',
        notes: '',
        resourceCategory: ''
      },

      isPersonnel: false,
      isResource: false,

      title: 'Resource request/assign',

      notificationEmail: true,
      notificationType: 'always',
      notificationList: [],
      notificationHideList: true,
      showEmailNotification: true,

      isSaving: false,

      errors: [],
      notice: new NoticeFactory(),

      init: function() {

        this.model.resourceCategory = resourceCategory;
        this.model.schedule = schedule;
        this.model.resourceTimeFrame = request.resourceTimeFrame;
        this.model.eventResource = request.eventResource;
        this.model.type = type;

        if (preset) {
          this.model.preset = preset;
          this.updatePreset();
        }

        if (request.notes) {
          this.model.notes = request.notes;
        }

        if (request.hasOwnProperty('eventResource') && request.eventResource.resourceCategory === 'Personnel') {
          this.notificationList.push(request.eventResource.resourceName);
        }


        this.notificationType = emailSetting;
        this.showEmailNotification = showEmailNotification;
        this.checkNotification();

        $scope.$on('ResourceRequestNeed::RequestCategoryUpdate', this.onRequestCategoryUpdate);
        $scope.$on('ResourceRequestNeed::RequestTypeUpdate', this.onRequestTypeUpdate);
      },

      hasErrors: function() {
        return (this.errors.length);
      },

      isType: function(_type) {
        return (type === _type);
      },

      updatePreset: function() {

        switch(this.model.preset) {
          case 'setup':
            this.title = 'Request/Assign Resource Before Event';
            break;
          case 'cleanup':
            this.title = 'Request/Assign Resource After Event';
            break;
          case 'event':
            this.title = 'Request/Assign Resource';
            /* falls through */
          default:
            // do nothing
        }

      },

      done: function() {
        $uibModalInstance.close(this.request);
        this.isSaving = false;
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      validate: function() {
        var r = true;

        if (!this.model.eventResource) {
          r = false;
        }else if (!this.model.eventResource.resourceTemplateId && !this.model.eventResource.resourceId) {
          r = false;
        }

        return r;
      },

      checkNotification: function() {
        if (this.notificationType === 'always') {
          this.notificationEmail = true;
        }else if (this.notificationType === 'never') {
          this.notificationEmail = false;
        }else if (this.notificationType === 'ask' && this.notificationHideList) {
          this.notificationEmail = true;
        }

        this.sendEmail = this.notificationEmail;
      },

      complete: function() {
        $scope.$broadcast('ResourceRequest::Complete');
        this.isSaving = true;
        if (this.validate()) {
          if (request && request.id) {
            this.updateRequest();
          } else {
            this.createRequest();
          }
        }else{
          this.isSaving = false;
          this.notice.showErrorMessages([{
            message: 'Please correct the errors below.'
          }]);
        }
      },

      createRequest: function() {

        var props;

        if (this.isType('instance')) {

          props = $.extend({
            id: schedule.id,
            sendEmail: this.notificationEmail
          }, this.model);

          ApiService.program.resources.instance.create(props).then(this.success.updateRequest, this.error.updateRequest);

        }else if (this.isType('template')) {

          props = $.extend({
            templateId: templateId,
            scheduleId: schedule.id,
            sendEmail: this.notificationEmail
          }, this.model);

          ApiService.program.resources.schedule.create(props).then(this.success.createRequest, this.error.createRequest);

        }

      },

      updateRequest: function() {

        var props;

        if (this.isType('instance')) {

          props = $.extend({
            id: request.id,
            eventId: schedule.id,
            sendEmail: this.notificationEmail
          }, this.model);

          ApiService.program.resources.instance.update(props).then(this.success.updateRequest, this.error.updateRequest);

        }else if (this.isType('template')) {

          props = $.extend({
            id: request.id,
            templateId: templateId,
            scheduleId: schedule.id,
            sendEmail: this.notificationEmail
          }, this.model);

          ApiService.program.resources.schedule.update(props).then(this.success.createRequest, this.error.createRequest);

        }


      },

      success: {
        init: function(response) {},

        createRequest: function(response) {
          var self = $scope.resourcesModalsRequest;

          self.request = response.data.payload;
          self.done();
        },

        updateRequest: function(response) {
          var self = $scope.resourcesModalsRequest;

          self.request = response.data.payload;
          if (self.request.eventResource) {
            var props = {
              eventId: self.model.schedule.id
            };
            ApiService.orders.analytics.sync(props).then(self.success.sync, self.error.sync);
          }
          self.done();
        },

        sync: function(response) {

        }
      },

      error: {
        init: function(response) {},

        createRequest: function(response) {
          var self = $scope.resourcesModalsRequest;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
          self.isSaving = false;
        },

        updateRequest: function(response) {
          var self = $scope.resourcesModalsRequest;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
          self.isSaving = false;
        },

        sync: function(response) {

        }
      },

      onRequestCategoryUpdate: function(e, data) {
        $scope.resourcesModalsRequest.isPersonnel = (data.resourceCategory === 'personnel') ? true : false;
      },

      onRequestTypeUpdate: function(e,data) {
        $scope.resourcesModalsRequest.isResource = (data.requestType === 'resource') ? true : false;
      }
    };

    $scope.resourcesModalsRequest.init();

}]);